<!--<div class="img-center"><img  src="./assets/edit4.jpg"></div>-->

<carousel-component></carousel-component>
<categories-menu-component></categories-menu-component>


